import { render, staticRenderFns } from "./order_product.vue?vue&type=template&id=0dafc0fe&scoped=true&"
import script from "./order_product.vue?vue&type=script&lang=js&"
export * from "./order_product.vue?vue&type=script&lang=js&"
import style0 from "./order_product.vue?vue&type=style&index=0&id=0dafc0fe&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dafc0fe",
  null
  
)

export default component.exports